import React, { Component } from 'react';

class EmailSignup extends Component {
    constructor(){
        super();
        this.state = {
            email: "",
            name: ""
        }
    }
    changeEmail(e) {
        this.setState({email:e.target.value});
    }
    changeName(e) {
        this.setState({name:e.target.value});
    }

    render() {
        return (
            <div>
                <h1>Keep in touch</h1>
                <form action="//anywaysnyc.us14.list-manage.com/subscribe/post?u=9e29827fce50a0ad75face260&amp;id=32575860e1" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" noValidate>
                    <input placeholder="email" type="email" value={this.state.email} onChange={this.changeEmail.bind(this)} name="EMAIL" id="mce-EMAIL" />
                    { this.props.includeName && <input placeholder="name (optional)" type="text" value={this.state.name} onChange={this.changeName.bind(this)} name="FNAME" id="mce-FNAME" /> }
                    <input type="submit" className="small-btn" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" />
                </form>
            </div>
        );
    }
}

export default EmailSignup;


// WEBPACK FOOTER //
// ./src/components/All/EmailSignup.js